import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "src/app/secondadmin/base.component";
import { MasterService } from "src/app/services/master/master.service";

@Component({
  selector: "app-edit-subscription-license-rights",
  templateUrl: "./edit-subscription-license-rights.component.html",
  styleUrls: ["./edit-subscription-license-rights.component.css"],
})
export class EditSubscriptionLicenseRightsComponent extends BaseComponent implements OnInit {
  customer_id;
  selectedCompany: string;
  sub_id: string;
  planTitle = "";
  licenses: any = [];
  actions = [
    { key: "can_view", label: "View" },
    { key: "can_add", label: "Add" },
    { key: "can_edit", label: "Edit" },
    { key: "can_execute", label: "Execute" },
    { key: "can_delete", label: "Delete" }
  ];
  constructor(private masterService: MasterService) {
    super();
  }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem("userData")).admin_customer_id;
    if (localStorage.getItem("edit_subscription_license_rights_id")) {
      this.sub_id = localStorage.getItem("edit_subscription_license_rights_id");
      this.selectedCompany = localStorage.getItem("edit_subscription_license_rights_company_id");
      this.loadRights();
    }
  }

  loadRights() {
    this.ngxSpinnerService.show();
    this.masterService.getSubscriptionLicenseRightsById(this.selectedCompany, this.sub_id).subscribe(response => {
      this.ngxSpinnerService.hide();
      if (response.status) {
        this.planTitle = response.data.title;
        this.licenses = response.data.licenses || [];
      } else {
        this.toastrService.error(response.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }

  isChecked(item, key) {
    return item[key] === true || item[key] === "t" || item[key] === "true";
  }

  toggle(item, key, checked) {
    item[key] = checked;
  }

  saveRights() {
    const rights = this.licenses.map(item => ({
      license_id: item.license_id,
      view: this.isChecked(item, "can_view"),
      add: this.isChecked(item, "can_add"),
      edit: this.isChecked(item, "can_edit"),
      execute: this.isChecked(item, "can_execute"),
      delete: this.isChecked(item, "can_delete")
    }));
    this.ngxSpinnerService.show();
    this.masterService.updateSubscriptionLicenseRights(this.selectedCompany, this.sub_id, { rights: rights }).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success("License rights update successfully");
        this.router.navigateByUrl(`/corporate/subscription-license-rights`);
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
